import type { FC } from 'react';
import { useQuery } from '@tanstack/react-query';

import { isAuthSessionActive, useAuthSession } from 'hooks/useAuthSession';
import { api, type ApiRequestConfig } from 'api/v1/api';

import { TutorNotice } from './TutorNotice';

type Readiness = {
  profile_complete: boolean;
  has_services: boolean;
  missing?: string[];
  message: string;
};

export const TutorProfileCompletionBanner: FC = () => {
  const { data: session } = useAuthSession();

  const { data } = useQuery<Readiness | null>({
    queryKey: ['tutor-profile-readiness'],
    queryFn: async () => {
      try {
        const r = await api.get('/profile/tutor/readiness', {
          skipGlobalErrorHandler: true,
        } as ApiRequestConfig);
        return r.data as Readiness;
      } catch {
        return null;
      }
    },
    enabled: isAuthSessionActive(session),
    staleTime: 60_000,
    retry: false,
  });

  if (!data || data.profile_complete) {
    return null;
  }

  const items: string[] = [];
  // Фамилию и дату рождения репетитор указывает в анкете после регистрации.
  if (data.missing?.includes('surname')) {
    items.push('Укажите фамилию');
  }
  if (data.missing?.includes('date_of_birth')) {
    items.push('Укажите дату рождения');
  }
  if (!data.has_services) {
    items.push('Укажите минимум одну услугу (предмет и цену)');
  }

  return (
    <TutorNotice
      tone='note'
      title='Заполните профиль для доступа к заявкам'
      text={data.message}
      items={items}
      linkTo='/teacher/edit'
      linkLabel='Продолжить заполнение профиля'
    />
  );
};
